module.exports = __webpack_public_path__ + "static/media/orders.56c76cdd.svg";